import React, { useState } from 'react';

import { ISearchBarState } from 'types/components/layouts/shared/search-box/index';

import SearchInput from './search-input.component';

const Mobile: React.FC = () => {
  const [state, setState] = useState<ISearchBarState>({
    open: false,
  });

  return (
    <React.Fragment>
      <div className="dropdown d-inline-block d-lg-none ms-2">
        <button
          className="btn header-item noti-icon"
          id="page-header-search-dropdown"
          onClick={() => {
            setState((state) => ({ ...state, open: !state.open }));
          }}
          type="button">
          <i className="mdi mdi-magnify" />
        </button>
        <div
          aria-labelledby="page-header-search-dropdown"
          className={
            state.open
              ? 'dropdown-menu dropdown-menu-lg dropdown-menu-end p-0 show'
              : 'dropdown-menu dropdown-menu-lg dropdown-menu-end p-0'
          }>
          <form className="p-3">
            <div className="form-group m-0">
              <div className="input-group">
                <SearchInput />
                <div className="input-group-append">
                  <button
                    className="btn btn-primary"
                    type="submit">
                    <i className="mdi mdi-magnify" />
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Mobile;
